import { Cache } from "memory-cache";
import { CorporationWalletJournalEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationWalletJournalEntity(
  id: number
): Promise<CorporationWalletJournalEntity | null> {
  let entity: any = await cache.get(id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationWalletJournalEntity(transaction: CorporationWalletJournalEntity) {
  cache.put(transaction.props.id.toString(), transaction, 60 * 60 * 1000 /* 1 hour */);
}
